import React from 'react';
import { Link, Navigate } from "react-router-dom"; // React Router ile yönlendirme
import Nav from '../components/Nav';
import { database, auth } from '../firebase';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      isModerator: null, // null = bilinmiyor, false = yetkisiz, true = yetkili
    };
  }

  componentDidMount() {
    auth.onAuthStateChanged((user) => {
      if (!user) {
        this.setState({ isModerator: false });
        return;
      }

      const userId = user.uid;

      // Moderatör mü kontrol et
      database.ref("users/" + userId).on("value", (snap) => {
        if (snap.exists() && snap.val().moderator === true) {
          this.setState({ isModerator: true });
        } else {
          this.setState({ isModerator: false });
        }
      });
    });

    // Kullanıcı listesini çek
    database.ref("users").on("child_added", (snap) => {
      this.setState((prevState) => ({
        users: [...prevState.users, { id: snap.key, ...snap.val() }]
      }));
    });
  }

  render() {
    // Eğer yetkili değilse yönlendir
    if (this.state.isModerator === false) {
      return <Navigate to="/" />;
    }

    return (
      this.state.isModerator ? <div id="aaaa">
        <Nav />
        <div className="users">
          <a style={{ fontSize: "17px" }}>Kullanıcılar</a>
          {this.state.users.map((user) => (
            <Link key={user.id} to={`/profil/${user.id}`}>
              <div className="card">
                <img src={user.userImage || "/default.jpg"} className="banner" alt="Profil Fotoğrafı"/>
                <b className="başlık">{user.userName}</b>
              </div>
            </Link>
          ))}
        </div>

        { /* TEST */ }
        <img src="/loading.svg" style={{ position: "absolute", left: "50%", top: "50%" }} alt="Logo" />

        <style>{`
          .users {
            width: 20%;
            height: 100%;
            position: fixed;
            max-width: 500px;
            margin-top: 50px;
            padding: 20px;
            text-align: center;
            font-size: 30px;
            background: #F57029;
            box-shadow: 0px 0px 4px rgba(0,0,0,.8);
            color: #fff;
          }

          .card {
            border-top: 2px solid #fff;
            margin: 10px;
            padding: 8px;
            background: #F57029;
            box-shadow: 0px 0px 4px rgb(0 0 0 / 0%);
            display: flex;
            transition: .2s;
          }

          .card:hover {
            background: #d95e1c;
          }

          .card .banner {
            display: block;
            margin-right: 10px;
            border-radius: 500px;
            width: 40px;
            height: 40px;
            object-fit: cover;
          }

          .başlık {
            display: block;
            line-height: 40px;
            color: #fff;
            text-align: center;
            font-size: 20px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          @media (max-width: 623px) {
            html {
              background: #F57029;
            }

            .main {
              margin-top: 100px;
              padding: 0px 0px;
              box-shadow: 0 0 0;
            }
          }
        `}</style>
      </div> : <></>
    );
  }
}

export default Dashboard;